module.exports = __webpack_public_path__ + "static/img/2.90fb086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/2.png
// module id = Z0sp
// module chunks = 2